import { 
  Component, 
  OnInit, 
  OnDestroy, 
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  signal
} from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { selectIsTracking, selectCurrentAppointmentId } from 'src/app/tracking/ngrx/tracking.selectors';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { MapsComponent } from 'src/app/tracking/maps/maps.component';
import { DialogService } from '../../services/dialog.service';

@Component({
  selector: 'app-tracking-banner',
  standalone: true,
  imports: [IonicModule, CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './tracking-banner.component.html',
  styleUrls: ['./tracking-banner.component.scss']
})
export class TrackingBannerComponent {
  isTracking = this.store.selectSignal(selectIsTracking);
  currentAppointmentId = this.store.selectSignal(selectCurrentAppointmentId);

  constructor(
    private store: Store,
    private dialogService: DialogService
  ) {}

  openTrackingMap() {
    if (this.currentAppointmentId()) {
        this.dialogService.openMaps(this.currentAppointmentId(), 0);
    }
  }
} 